import { mapActions } from "vuex";
import {CHECK_REGISTERED_BROKER_USER,USER_LOGIN,USER_LOGOUT, CHECK_USER_CKYC, GET_USER_SUBSCRIPTION, GET_LEGAL_AGREEMENT,	SAVE_LEGAL_AGREEMENT, GET_USER_INFO} from '@/store/actions.type'
var axios = require('axios');
import { Tweet, Moment, Timeline } from 'vue-tweet-embed'
import arDisclaimer from './../../components/Dialogs/arDisclaimer.vue';
import ckycmodal from './../../components/Dialogs/CKYCModal.vue'
import legalagreementpopup from './../../components/legalagreementpopup.vue'
import {API_URL} from "../../api/config";
import disclaimerdis from './../../components/Disclaimer.vue'
import legalagreementpostpayment from "../../components/legalagreementpostpayment.vue";
import { announceValidationErrorsViaStatus } from '@/utils/formValidationAnnounce';

const PARTNER_FORM_SUCCESS_MESSAGE =
  'Your query has been received. Our sales team will get back to you soon.';

export default {
  data() {
    return {
      name:'',
      menuId: this.$route.params.id,
      email:'',
      mobilenumber:'',
      partnerMessage:false,
      partnerStatusMessage: '',
      usermessage:'',
      country: "+91",
      isLoggedin: false,
			isBrokerUser: false,
      showArDisclaimer:false,
      showRegisterButton: true,
      isBrokerGuest: false,
      isCKYCDone: true,
      isPremium: false,
      showCkycModal: false,
      ckycHref: '',
      showLegalAgreement: false,
			legalAgreementContent:"",
			legalAgreementId:0,
            showEsign:false,
			legalAgreementContentEsign:"",
			esignRecord:null,
			isEsignActive:false
    };
  },

  components: { arDisclaimer, ckycmodal, legalagreementpopup, Tweet, Moment, Timeline, disclaimerdis, legalagreementpostpayment},


  created () {

    if(this.$route.query.utm_source){
        localStorage.setItem('utmParams',window.location.href.split('?').pop());

        // this.$toastr.Add({
        //     name: "disclaimer",
        //     msg: "“Anand Rathi Share & Stock Brokers Ltd does not provide investment advisory or online portfolio evaluation services. If a client is interested in portfolio evaluation services, they can avail of these services through William O’Neil India Pvt. Ltd. Any discrepancies/disputes will remain between a client & William O’Neil India Pvt. Ltd. Anand Rathi Share & Stock Brokers Ltd will not participate or be a party in any dispute.”",
        //     type: "info", // Toast type,
        //     position: "toast-top-full-width",
        //     clickClose: true, // Click Close Disable
        //     timeout: 0,
        //     showCloseButton: true,
        //   });
    }
    this.checkauth()
    this.checkIsBrokerUser();
    if(!this.isLoggedin && localStorage.getItem('utmParams')!=undefined && localStorage.getItem('utmParams')!=null)
    {
        this.isRegisteredBrokerUser();
    }
    else if (this.isLoggedin && localStorage.getItem('userType') == "2"){
        this.$router.replace('/evaluation/');
    }
},

computed: {

  userDetails () {
      return this.$store.state.authentication.user
  },
  isRedirectedBrokerUrl(){
      return (localStorage.getItem('utmParams')==undefined || localStorage.getItem('utmParams')==null
      || localStorage.getItem('utmParams') == 'utm_source=ARGuest' )?false:true;
  },
  fetchUserSubscription() {
      return this.$store.state.home.subscription
  }
},

  methods:{
    ...mapActions({
      isRegisteredBrokerUserCall: CHECK_REGISTERED_BROKER_USER,
      usersignin: USER_LOGIN,
      userlogout: USER_LOGOUT,
      getusersubscription: GET_USER_SUBSCRIPTION,
      checkuserckyc: CHECK_USER_CKYC,
      getlegalagreement: GET_LEGAL_AGREEMENT,
      savelegalagreement: SAVE_LEGAL_AGREEMENT,
      getIsCkyc: GET_USER_INFO


    }),



    callbackform(){
      this.$validator.validateAll().then((result) => {
        if (result) {
            this.partnerform()
        } else {
            announceValidationErrorsViaStatus(this, 'partnerStatusMessage', this.errors);
        }
    });

    },

    closeCkycModal() {
      this.showCkycModal = false;
      this.ckycHref = '';
    },

    announcePartnerFormStatus() {
      this.partnerStatusMessage = '';
      this.$nextTick(() => {
        this.partnerStatusMessage = PARTNER_FORM_SUCCESS_MESSAGE;
      });
    },

    async partnerform(){
        let res = ''
        await axios.post(API_URL+ 'notification/requestAcallback', {"name":this.name,
        "email":this.email,
        "mobile":this.country+this.mobilenumber,
        "message":this.usermessage})
         .then(function (response) {
            res = response.data.response.success
         })
         if(res){
            this.$notify({
                group: 'allAlerts',
                title: '',
                type: 'success',
                text: `<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-success fa fa-check-circle" aria-hidden="true"></i></span> <span class="notificationText">${PARTNER_FORM_SUCCESS_MESSAGE}</span></div>`
            });
            this.partnerMessage = true;
            this.announcePartnerFormStatus();
            this.name='';
            this.email='';
            this.country=this.country;
            this.mobilenumber='';
            this.usermessage='';
            this.$validator.reset()

            }

    },

    async checkauth () {
      debugger;
      console.log('checkauth called' )
      if (localStorage.getItem('psitoken')) {
         console.log('psitoken called' )
          this.isLoggedin = true;
          if (localStorage.getItem('userType') != "2") {
            console.log('getCkycPopup called')
            this.getCkycPopup()
          }
      }
      else {
          this.isLoggedin = false;
      }
  },

  async getCkycPopup () {
    console.log('getCkycPopup called')
      let psitoken = localStorage.getItem('psitoken');
      if(psitoken){
        await this.getIsCkyc(psitoken).then((response) => {
          if(response.user.isCKYC == 1){
            this.checkCkycStatus ()
          } else {
                this.getActiveLegalAgreement("PSI",localStorage.getItem("uid"));

                if(!this.showLegalAgreement) {
                    this.checkEsignStatus();
                }
            }
        })
      }else{
      }
    },

  async checkCkycStatus () {
    await this.getusersubscription().then(async subsdata => {
      let params = {
        "user_email": localStorage.getItem('uemail')
        }
        if (subsdata != null) {
            this.isPremium = subsdata.remainingAccess > 0 ? true : false
        }

        await this.checkuserckyc(params).then(data => {
            this.isCKYCDone = data.success
            console.log('isCKYCDone', this.isCKYCDone)
            console.log('isPremium', this.isPremium)
            if (!data.success && this.isPremium) {

                const userId = this.$store.state.authentication.user.id
                const emailId = this.$store.state.authentication.user.email
                const safeUrl = encodeURIComponent(window.location.href);
                const href = `https://ckycui-dot-msi-gcloud-prod.el.r.appspot.com/?uid=${userId}&prod=PSI&email=${emailId}&url=${safeUrl}`;
                this.ckycHref = href;
                this.showCkycModal = true;
            }
            else {
                this.getActiveLegalAgreement("PSI",localStorage.getItem("uid"));

                if(!this.showLegalAgreement) {
                    this.checkEsignStatus();
                }
            }
        })
    });
  },

  async getActiveLegalAgreement (productCode,userId) {
    var self = this;
    var payload = {
        userId:userId,
        productCode: productCode
    };
    await this.getlegalagreement(payload).then(result => {
        if(result!=null){
            self.showLegalAgreement = !result.isUserAccepted;
            self.legalAgreementContent = result.description;
            self.legalAgreementId = result.id;
        }
    });
},

async saveLegalAgreement() {

    var self = this;
    var payload = {
        userId:localStorage.getItem("uid"),
        legalAgreementId:self.legalAgreementId,
        isAccepted:1
    };
    await this.savelegalagreement(payload).then(result => {
        if(result!=null){
        }

    });
},

checkIsBrokerUser () {
if(window.location.href.indexOf('/ar') > -1)
    {
        this.isBrokerUser = true;
        this.showRegisterButton = false;
    }
else
    {
        this.isBrokerUser = false;
        this.showRegisterButton = true;
    }

},

cancelModal (action) {
    this.showArDisclaimer=false;
  },

async isRegisteredBrokerUser () {
    if( localStorage.getItem('utmParams')!= 'utm_source=ARGuest'){
        this.userlogout();
    }
    await this.isRegisteredBrokerUserCall({'utmParam':localStorage.getItem('utmParams')})
    .then(respnse => {
        if(respnse.isBrokerUserExists)
        {
            this.userLogin(respnse.email,respnse.clientCode)
            //this.$router.replace('/login');
        }
        else if (localStorage.getItem('utmParams') == 'utm_source=ARGuest') {
            this.isBrokerGuest = true;
            this.showArDisclaimer=true;
        }
        else{
            this.showArDisclaimer=true;
            this.showRegisterButton = true;
        }
    });
},
async logout () {
    var self = this;
    await this.userlogout().then(data => {
        self.$store.commit('LOGOUT_USER');
    });
},

async userLogin (email,password) {
    var self = this;
    var userObj = { email: email, password:  password}
    await this.usersignin(userObj).then(data => {
        if (data.response.success) {
            self.$router.replace('/evaluation/');
        } else {
            if (data.response.providers && data.response.providers.length > 0) {
                var providers = self.processProviders(data.response.providers);
                this.$notify({
                    group: 'allAlerts',
                    title: '',
                    type: 'error',
                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + data.response.message + '  ' + providers + ' </span></div>'
                });
            } else {
                this.$notify({
                    group: 'allAlerts',
                    title: '',
                    type: 'error',
                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + data.response.message + ' </span></div>'
                });
            }
        }
    });
},

loginbtn (postId) {
  this.$router.push("/login/" + postId);
},

async fetchAgreement() {
    try {
        const response = await axios.get('https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/userlegalagreement/agreementtype.json', {
            params: {
                productCode: 'psi',
                agreementtype: 3,
            },
        });
        this.legalAgreementContentEsign = response.data.data.description;
        this.isEsignActive = response.data.data.isEsign === 1;
    } catch (error) {
    }
},

async checkEsignStatus() {
    try {
        const userId = localStorage.getItem("uid");
        const productType = "psi";
        const response = await axios.get("https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/user/isEsignDone.json", {
            params: { userId, productType }
        });
        const responseData = response?.data?.data;

        if (responseData?.success === false) {
            this.esignRecord = {
                id: responseData.id ?? null,
                UserId: responseData.UserId ?? null,
                product: responseData.product ?? null,
                transactionId: responseData.transactionId ?? null,
                pdflink: responseData.pdflink ?? null,
                createdDate: responseData.createdDate ?? null,
                updatedDate: responseData.updatedDate ?? null
            };
            this.fetchAgreement();
            this.showEsign = true;
        } else {
            this.showEsign = false;

        }
    } catch (error) {
    }
},


  }
};




// WEBPACK FOOTER //
// ./src/assets/js/home.js